import { computed } from "vue"
import VueI18n from "vue-i18n"

import i18n from "@/i18n"
import { SyncFrequency } from "@/types/sync.type"

interface SelectOption<T = string> {
  label: VueI18n.TranslateResult
  value: T
}

type UploadStatus = "ACTIVE" | "ALL"
type SortOrder = "ascend" | "descend" | ""

export const useSyncOptions = () => {
  const uploadProductsOptions = computed<SelectOption<UploadStatus>[]>(() => [
    {
      label: i18n.t("synchronization.upload_products.in_stock"),
      value: "ACTIVE"
    },
    {
      label: i18n.t("synchronization.upload_products.all"),
      value: "ALL"
    }
  ])

  const updateProductOptions = computed<SelectOption<SyncFrequency>[]>(() => [
    {
      label: i18n.t("synchronization.update_info.every_1_hour"),
      value: "HOURLY"
    },
    {
      label: i18n.t("synchronization.update_info.every_4_hours"),
      value: "EVERY_FOUR_HOUR"
    },
    {
      label: i18n.t("synchronization.update_info.every_day"),
      value: "DAILY"
    }
  ])

  const editPricesOptions = computed<SelectOption<SortOrder>[]>(() => [
    {
      label: i18n.t("synchronization.edit_prices.ascend"),
      value: "ascend"
    },
    {
      label: i18n.t("synchronization.edit_prices.descend"),
      value: "descend"
    },
    {
      label: i18n.t("synchronization.edit_prices.none"),
      value: ""
    }
  ])

  return {
    uploadProductsOptions,
    updateProductOptions,
    editPricesOptions
  }
}
